import type { Reactive } from 'vue';
import type { MovieList } from 'src/models/movie';
import type { GIMovieList, GIResource, MapSelectOpts } from 'src/models/geoItem';
import type { TopMovieSearch } from 'src/models/top';

export interface MovieSearchResultInteractionContext {
  onMovieSearchResultRowClick: (obj: GIMovieList) => void;
  onMovieSearchResultPlayClick: (evt: Event, obj: MovieList | GIMovieList) => void;
}

// 検索結果一覧の行クリック・再生クリック操作を担うcomposable。
// レイヤー再描画はexecution側のrefreshMovieLayerを注入してもらう。
export function useMovieSearchResultInteraction(deps: {
  movieSearchState: Reactive<TopMovieSearch>;
  refreshMovieLayer: () => void;
  afterDataLayerItemClick: (dataName: string, obj: GIResource, opts?: MapSelectOpts) => void;
  afterMoviePlayClick: (obj: MovieList | GIMovieList) => void;
}): MovieSearchResultInteractionContext {
  const { movieSearchState, refreshMovieLayer, afterDataLayerItemClick, afterMoviePlayClick } = deps;

  const onMovieSearchResultRowClick = (obj: GIMovieList) => {
    const isSelected = !obj.isSelected;
    movieSearchState.results.forEach(e => { e.isSelected = false; });
    obj.isSelected = isSelected;
    refreshMovieLayer();
    afterDataLayerItemClick('movie', obj);
  };
  const onMovieSearchResultPlayClick = (evt: Event, obj: MovieList | GIMovieList) => {
    evt.preventDefault();
    evt.stopImmediatePropagation();
    afterMoviePlayClick(obj);
  };

  return {
    onMovieSearchResultRowClick,
    onMovieSearchResultPlayClick,
  };
}
